import { render } from "./TroubleShooting.vue?vue&type=template&id=40ad7caf&scoped=true&ts=true"
import script from "./TroubleShooting.vue?vue&type=script&lang=ts"
export * from "./TroubleShooting.vue?vue&type=script&lang=ts"

import "./TroubleShooting.vue?vue&type=style&index=0&id=40ad7caf&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ad7caf"]])

export default __exports__